import { Box, GridItem } from '@flos/react-ui';
import SingleTripMissingInformationForm from '../SingleTripMissingInformationForm';
import { useRecoilValue } from 'recoil';
import { missingInformationAtom } from '../../../../recoil/atoms/missingInformationAtom';

const SingleTripMissingInformation = (): React.JSX.Element => {
    const missingInformation = useRecoilValue(missingInformationAtom);
    const { singleTripTravel, singleTripCancellation } = missingInformation;

    return (
        <>
            {singleTripTravel && (
                <GridItem span={12}>
                    <Box>
                        <h6>Enkeltrejseforsikring</h6>
                        {singleTripTravel.map((person, index) => (
                            <div key={person.fixedId}>
                                <SingleTripMissingInformationForm
                                    singleTripMissingDTO={person}
                                    isMultiplePersons={singleTripTravel.length > 1}
                                    isSTT={true}
                                    personIndex={String(index + 1)}
                                />
                            </div>
                        ))}
                    </Box>
                </GridItem>
            )}
            {singleTripCancellation && (
                <GridItem span={12}>
                    <Box>
                        <h6>Afbestillingsforsikring til enkeltrejse</h6>
                        {singleTripCancellation.map((person, index) => (
                            <div key={person.fixedId}>
                                <SingleTripMissingInformationForm
                                    singleTripMissingDTO={person}
                                    isMultiplePersons={singleTripCancellation.length > 1}
                                    isSTT={false}
                                    personIndex={String(index + 1)}
                                />
                            </div>
                        ))}
                    </Box>
                </GridItem>
            )}
        </>
    );
};

export default SingleTripMissingInformation;
